var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#E2E2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5842,
    transform: "translate(-1197 -5672)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1197,
    y: -206,
    width: 1440,
    height: 376,
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.00073,
    cy: 7,
    r: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.48173 0H3.51971C1.57931 0 0.000732422 1.57858 0.000732422 3.51898V9.4811C0.000732422 11.4214 1.57931 13 3.51971 13H9.48183C11.4221 13 13.0007 11.4214 13.0007 9.4811V3.51898C13.0007 1.57858 11.4221 0 9.48173 0V0ZM12.2386 9.4811C12.2386 11.0012 11.0019 12.2379 9.48173 12.2379H3.51971C1.99955 12.2379 0.762847 11.0012 0.762847 9.4811V3.51898C0.762847 1.99881 1.99955 0.762114 3.51971 0.762114H9.48183C11.0019 0.762114 12.2386 1.99881 12.2386 3.51898V9.4811Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50075 2.94531C4.54071 2.94531 2.94617 4.53986 2.94617 6.49989C2.94617 8.45993 4.54071 10.0545 6.50075 10.0545C8.46078 10.0545 10.0553 8.45993 10.0553 6.49989C10.0553 4.53986 8.46078 2.94531 6.50075 2.94531ZM6.50075 9.29236C4.96105 9.29236 3.70828 8.03969 3.70828 6.49989C3.70828 4.96019 4.96105 3.70743 6.50075 3.70743C8.04055 3.70743 9.29322 4.96019 9.29322 6.49989C9.29322 8.03969 8.04055 9.29236 6.50075 9.29236Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1403 1.68311C9.56108 1.68311 9.08997 2.15432 9.08997 2.73344C9.08997 3.31266 9.56108 3.78388 10.1403 3.78388C10.7195 3.78388 11.1907 3.31266 11.1907 2.73344C11.1907 2.15422 10.7195 1.68311 10.1403 1.68311ZM10.1403 3.02166C9.98141 3.02166 9.85208 2.89233 9.85208 2.73344C9.85208 2.57445 9.98141 2.44522 10.1403 2.44522C10.2993 2.44522 10.4286 2.57445 10.4286 2.73344C10.4286 2.89233 10.2993 3.02166 10.1403 3.02166Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -24.9993,
    y: -20,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 5842,
    fill: "white",
    transform: "translate(-1197 -5672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.16853c0a3077277f1b7e7f80e6cf755f.svg";
export { ForwardRef as ReactComponent };